import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import { removeDeletedDateFromSerialNo } from '../../../utils/removeDeletedDateFromSerialNo';
import BasicModal from '../../../components/BasicModal';
import FontWeight from '../../../styles/font-weights';

interface Props {
    isVisible: boolean;
    setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
    cameraHistory?: CameraHistoryPage | MaintenanceRequests;
}

function SideBarItem(props: { title: string; content: string; direction: 'row' | 'column'; contentTextColor?: string; }) {
    const { styles } = useStyles(stylesheet);

    return <View style={{ flexDirection: props.direction, gap: props.direction === 'row' ? 8 : 0 }}>
        <MyAppText style={styles.sideBarItemTitle}>{props.title}:</MyAppText>
        <MyAppText style={[styles.sideBarItemContent, props.contentTextColor ? { color: props.contentTextColor } : undefined]}>{props.content}</MyAppText>
    </View>;
}

export default function CameraInformationModal({ isVisible, setIsVisible, cameraHistory }: Props) {
    const { theme } = useStyles(stylesheet);

    if (!cameraHistory) {
        return <></>;
    }

    return (
        <BasicModal
            isModalVisible={isVisible}
            setModalVisible={setIsVisible}
            title={translate('cameraInfoLabel')}
            cancelButton={{
                customText: translate('close'),
            }}
            width='medium'
            mobileHeight='fit'
        >
            <View style={{ gap: 4 }}>
                <SideBarItem title={translate('Id')} content={cameraHistory.camera.id} direction='row' />
                <SideBarItem title={translate('title')} content={cameraHistory.camera.title} direction='column' />
                <SideBarItem title={translate('serialNo')} content={removeDeletedDateFromSerialNo(cameraHistory.camera.serialNo ?? '')} direction='row' />
                <SideBarItem title={translate('address')} content={cameraHistory.camera.address} direction='column' />
                <SideBarItem title={translate('stolen_equipment')} content={cameraHistory.camera.stolen ? translate('yes') : translate('no')} direction='row' />
                <SideBarItem
                    title={translate('currentlyOnline')}
                    contentTextColor={cameraHistory.camera.isConnected ? theme.colors.online.fontColor : theme.colors.offline.fontColor}
                    content={cameraHistory.camera.isConnected ? translate('online') : translate('offline')} direction='row'
                />
                <SideBarItem title={translate('disabled')} content={cameraHistory.camera.disabledAt !== null ? translate('yes') : translate('no')} direction='row' />
                <SideBarItem title={translate('femaleDeleted')} content={cameraHistory.camera.deletedAt !== null ? translate('yes') : translate('no')} direction='row' />
            </View>
        </BasicModal>
    );
}

const stylesheet = createStyleSheet(theme => ({
    sideBarItemTitle: {
        fontSize: 14,
        color: theme.colors.neutral[500],
        fontWeight: FontWeight.semiBold,
    },
    sideBarItemContent: {
        fontSize: 14,
        color: theme.colors.neutral[400],
    },
}));
